// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const VERSION_ID = process.env.GIT_SHA || "development";

Sentry.init({
  dsn:
    SENTRY_DSN ||
    "https://919173d05f354a6c96b919b8b8a77bb3@o1219600.ingest.sentry.io/6678549",
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  release: VERSION_ID,
  // stop Sentry from logging `console.log` messages
  integrations: [
    Sentry.breadcrumbsIntegration({
      console: false,
    }),
  ],
});
